'use client';

import { useEffect } from 'react';
import { trackException } from '@/lib/monitoring/appInsights';

export default function ErrorPage({
  error,
  reset,
}: {
  error: Error & { digest?: string };
  reset: () => void;
}) {
  useEffect(() => {
    trackException(error);
    if (error.digest) {
      console.error('[ErrorBoundary] digest:', error.digest);
    }
  }, [error]);

  return (
    <div className="flex min-h-[50vh] flex-col items-center justify-center p-8 text-center font-[var(--font-poppins),sans-serif]">
      <h1 className="mb-4 text-5xl font-semibold text-brand-dark">
        Noget gik galt
      </h1>
      <p className="mb-6 max-w-md text-gray-500">
        Der opstod en uventet fejl. Prøv venligst igen, eller kontakt os hvis
        problemet fortsætter.
      </p>
      <button
        type="button"
        onClick={reset}
        className="cursor-pointer rounded-lg border-2 border-transparent bg-brand-dark px-6 py-3 text-base font-medium text-white outline-none focus-visible:shadow-[0_0_0_3px_var(--color-brand-teal)]"
      >
        Prøv igen
      </button>
    </div>
  );
}
